import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { SideNavId } from "../../../enums/StringLiterals/sideNavId";
import { SideNavLabel } from "../../../enums/StringLiterals/sideNavLabel";
import { useFetchPdfUrl } from "../../../pages/pharmaPrimaryCare/hooks/useFetchPdfUrl";
import SideNavElement from "../../sideNavElement/sideNavElement";
import DocumentTab from "./components/documentTab";
import TaskHistoryTab from "./components/taskHistoryTab";
import { useRefetchAttachment } from "./hooks/useRefetchAttachment";

interface PrimaryCarePdfModalProps {
  filePath?: string;
  identifier?: string;
  taskHistory?: string;
  onClose: () => void;
}

const tabs = [
  { id: SideNavId.TASK_HISTORY, label: SideNavLabel.TASK_HISTORY },
  { id: SideNavId.DOCUMENT, label: SideNavLabel.DOCUMENT },
];

const PrimaryCarePdfModal = (props: PrimaryCarePdfModalProps) => {
  const { pdfUrl, isLoading } = useFetchPdfUrl(props.filePath);
  const [selectedTab, setSelectedTab] = useState<string>(SideNavId.DOCUMENT);

  const { refetchAttachment } = useRefetchAttachment(() => {
    props.onClose();
  });

  const handleRefreshClick = () => {
    if (props.identifier) {
      refetchAttachment(props.identifier);
    }
  };

  const renderContent = () => {
    switch (selectedTab) {
      case SideNavId.TASK_HISTORY:
        return <TaskHistoryTab taskHistory={props.taskHistory} />;
      case SideNavId.DOCUMENT:
        return (
          <DocumentTab
            pdfUrl={pdfUrl}
            isLoading={isLoading}
            identifier={props.identifier}
            onRefresh={handleRefreshClick}
          />
        );
    }
  };

  return (
    <Modal
      dialogId={ModalId.PRIMARY_CARE_PDF_MODAL}
      onSave={props.onClose}
      title={"Primary Care PDF"}
      saveButtonText={"Close"}
      cancelText={"Cancel"}
      onCancel={props.onClose}
      onClose={props.onClose}
      heightPercentage={80}
      showSingleButton={true}
      hideFooter={true}
    >
      <div className="flex h-full flex-col">
        <div className="flex flex-1 gap-1 overflow-hidden">
          <div className="side-nav--container flex w-[25%] flex-col overflow-y-auto">
            {tabs.map((tab) => (
              <SideNavElement
                key={tab.id}
                id={tab.id}
                label={tab.label}
                active={tab.id === selectedTab}
                onSelect={(id) => setSelectedTab(id)}
              />
            ))}
          </div>
          <div className="content--container flex h-full w-[75%] flex-1 flex-col bg-primaryGray-16 pb-3">
            {renderContent()}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PrimaryCarePdfModal;
